import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin.js';

class ScrolltoAnchor {

    constructor(){

        gsap.registerPlugin(ScrollToPlugin);

        console.log('ScrolltoHash')

        gsap.set(window, {scrollTo: 0});

        let hash = window.location.hash;

        // eslint-disable-next-line no-unused-vars
        let target = window.location.hash;
        target = target.replace('#', '');

        window.location.hash = '';

        console.log('hash', hash);

        if (hash) {
            console.log('has a hash')

            let scrollYPos = ($(hash).offset().top);

            gsap.to(window, {scrollTo: {y: scrollYPos, x: 0, autoKill: false}, duration:1, delay:0.5, ease: 'power2.inOut'});
        }


        $('.anchor').on('click', function ( event ) {

            event.preventDefault();

            let target = $(this).attr('href');

            console.log('target ', target)

            var scrollYPos = ($(target).offset().top);

            gsap.to(window, {scrollTo: {y: scrollYPos, autoKill:false}, ease: 'power2.inOut', duration:1});

        });

    }
}

export default ScrolltoAnchor



// WEBPACK FOOTER //
// ./scripts/util/scrolltoAnchor.js